import React from 'react';
import HelpMenu from 'components/HelpMenu';

function KnowledgeHelpMenu(props) {
  return (
    <HelpMenu align="right" {...props} />
  );
}

export default KnowledgeHelpMenu;
